<template>
  <div class="user-icon__wrapper" :class="dynamicWrapperClass">
    <button
      v-if="isUserWithFullNameWithoutAvatar"
      tabindex="-1"
      class="user-icon__avatar-without-image"
    >
      <span>{{ userInitials }}</span>
    </button>
    <div v-else class="user-icon__image-wrapper">
      <a-image
        :src="photo"
        :aspect-ratio="1"
        object-fit="cover"
        :alt="userFullName"
        class="user-icon__image"
      />
    </div>

    <a-icon
      :icon="$options.consts.ICON.ARROW_DOWN_WHITE"
      :width="10"
      :height="6"
      :original="true"
      :no-hover="true"
      class="user-icon__arrow"
    />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { mapGetters } from 'vuex'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

const DEFAULT_AVATAR = 'default-avatar.svg'

export default {
  name: 'AUserIcon',
  components: { AIcon },
  props: {
    isActive: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    ICON
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/userDetails',
      userFullName: 'auth/userFullName',
      userInitials: 'auth/userInitials'
    }),
    dynamicWrapperClass() {
      return {
        active: this.isActive
      }
    },
    isUserWithFullNameWithoutAvatar() {
      return !this.userDetails.PhotoUrl && this.userInitials
    },
    photo() {
      return this.userDetails.PhotoUrl
        ? this.$helper.forceUrlFetch(this.userDetails.PhotoUrl)
        : this.$helper.getLinkToIlBucketFile(DEFAULT_AVATAR)
    }
  }
}
</script>

<style lang="scss" scoped>
$avatar-size: 40px;

.user-icon__wrapper {
  border-radius: 40px;
  width: 67px;
  height: 44px;
  padding: 2px 3px;
  background: $c--gray-darkest-2;
  overflow: hidden;
  display: flex;
  align-items: center;

  &.active {
    background: $c--main;

    .user-icon__arrow {
      top: 6px;
    }
  }

  .user-icon__avatar-without-image {
    width: $avatar-size;
    height: $avatar-size;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(to bottom, #595959, #292929);
    font-size: 14px;
    text-transform: capitalize;
    color: $c--white;
    white-space: nowrap;
    font-weight: 600;
    line-height: 10px;
    border-radius: 50%;

    @include mobile {
      font-size: 10px;
    }

    & span {
      font-weight: normal;
      letter-spacing: 2px;
      padding-left: 2px;
    }
  }

  .user-icon__image-wrapper {
    width: $avatar-size;
    height: $avatar-size;
    border-radius: 50%;
    overflow: hidden;
  }

  .user-icon__arrow {
    position: relative;
    margin-left: 5px;
    top: 0;
    transition: $header-transition;
  }
}
</style>
